module.exports = __webpack_public_path__ + "img/american-samoa.35bca85b.png";